import { render, staticRenderFns } from "./IngredientList.vue?vue&type=template&id=607a07e0&"
import script from "./IngredientList.vue?vue&type=script&lang=js&"
export * from "./IngredientList.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports